export const LOGIN_REDIRECT_PATH = '/home';
